import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import { store } from "store";
import i18n from "i18n";
var StartView = /** @class */ (function (_super) {
    tslib_1.__extends(StartView, _super);
    function StartView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.enabledLocales = i18n.enabledLocales;
        return _this;
    }
    Object.defineProperty(StartView.prototype, "hasDevices", {
        get: function () { return store.devices.length > 0; },
        enumerable: true,
        configurable: true
    });
    StartView.prototype.created = function () {
        var locale = localStorage.getItem("deviceLocale");
        if (!locale)
            locale = "en";
        this.locale = locale;
        this.setLocale(locale);
    };
    StartView.prototype.routed = function () {
        this.$router.clearHistory();
    };
    StartView.prototype.openlist = function (event) {
        event.classlist.toggle('active');
    };
    StartView.prototype.localeChanged = function (e) {
        this.setLocale(e.target.value);
    };
    StartView.prototype.setLocale = function (locale) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                localStorage.setItem("deviceLocale", this.locale);
                this.$i18n.locale = locale;
                return [2 /*return*/];
            });
        });
    };
    StartView.prototype.mounted = function () {
        if (localStorage.getItem('deviceLocale'))
            this.$i18n.locale = localStorage.getItem('deviceLocale');
    };
    StartView = tslib_1.__decorate([
        Component
    ], StartView);
    return StartView;
}(Vue));
export default StartView;
